import React from 'react'
import { Fishx, Link } from 'fishx';
import routes from './config/routes'

const wrapperStyle = {
  textAlign: 'center',
  fontSize: '18px',
};

const h1Style = {
  fontSize: '40px',
  background: '#7898f3',
  marginBottom: '30px',
};


export default () => {
  const renderRoutes = routes => {
    return (
      <ul>
        {routes.map((route, i) => {
          if (!route.path) return null
          return (
            <li key={route.path || i}>
              <Link to={route.path}>{route.path}</Link>
              {route.childrens ? renderRoutes(route.childrens) : null}
            </li>
          )
        })}
      </ul>
    )
  }

  return (
    <div style={wrapperStyle}>
      <h1
        style={h1Style}
      >
        Hi, this is Fishx development 404 page
      </h1>
      <p>
        There's not a page yet at <code>{Fishx.history?.location?.pathname}</code>
        .
      </p>
      <h2>Your Routes</h2>
      {renderRoutes(routes)}
    </div>
  )
}
